import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { makeSelectRuntimeConfig } from '../../containers/App/selectors';

function EnvironmentBanner({ runtime = {} }) {
  const [bannerDismissed, setBannerDismissed] = useState(false);
  if (bannerDismissed || (runtime && runtime.DEPLOYMENT_ENVIRONMENT === 'production')) {
    return null;
  }
  const env = (runtime && runtime.DEPLOYMENT_ENVIRONMENT) || 'unknown';
  const banner = `ALERT: You are currently on a ${env} environment, Data and behavior may not reflect current product state.`;
  return (
    <div className="navbar sticky-top navbar-warning bg-warning py-2">
      <div className="d-inline-block col-11">{banner}</div>
      <div className="d-inline-block col-1">
        <button type="button" className="btn btn-light btn-sm" color="secondary" size="sm" onClick={() => { setBannerDismissed(true); }}>
          Dismiss
        </button>
      </div>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  runtime: makeSelectRuntimeConfig(),
});

EnvironmentBanner.propTypes = {
  runtime: PropTypes.shape({ DEPLOYMENT_ENVIRONMENT: PropTypes.string }),
};

const withConnect = connect(
  mapStateToProps,
);

export default compose(withConnect)(EnvironmentBanner);
